import styled from '@emotion/styled';

export const Button = styled.button`
  &::before {
    display: none;
    z-index: 100000000;
    content: '';
  }
  ${({ theme }) => theme.media.tablet} {
    height: 100%;
  }
`;

export const Quote = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;

export const QuoteContainer = styled.div`
  position: absolute;
  top: -70px;
  left: -50px;
  width: 30px;
  height: 30px;

  ${({ theme }) => theme.media.tablet} {
    left: auto;
    right: 0;
  }
`;

export const Author = styled.div`
  padding-top: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const PrevArrow = styled.div`
  border: 3px solid white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transform: rotate(180deg);
  ${({ theme }) => theme.media.tablet} {
    border: 0;
    bottom: -31px;
  }
`;

export const NextArrow = styled.div`
  border: 3px solid white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  position: absolute;

  ${({ theme }) => theme.media.tablet} {
    border: 0;
    bottom: -31px;
    left: -18px;
  }
`;

export const SliderWrapper = styled.div`
  & * {
    outline: none;
  }
  & .slick-dots li button:before {
    content: '';
  }

  & .slick-dots li button {
    position: absolute;
    background: transparent;
    border: 1px solid white;
    width: 8px;
    border-radius: 50%;
    height: 8px;
  }

  & .slick-dots li.slick-active button {
    background: white;
  }
`;
